import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { categoryService } from "services/category.api";
import { selectCategoryItems } from "store/categorySlice";
import { setCategoryItems } from "store/categorySlice";

const useCategory = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const categoryList = useSelector(selectCategoryItems);
  const [error, setError] = useState(null);

  const getcategoryList = async (data) => {
    setLoading(true);
    try {
      const response = await categoryService.fetchList(data);
      if (response.success) {
        dispatch(setCategoryItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const createcategory = async (payload) => {
    setLoading(true);
    try {
      const response = await categoryService.createCategory(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const updatecategory = async (id, payload) => {
    setLoading(true);
    try {
      const response = await categoryService.updateCategory(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deletecategory = async (id) => {
    setLoading(true);
    try {
      const response = await categoryService.deleteCategory(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getcategoryById = async (id) => {
    setLoading(true);
    try {
      const response = await categoryService.fetchCategoryById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getCategoryOptions = async () => {
    setLoading(true);
    try {
      const response = await categoryService.fetchCategoryOptions();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getcategoryList,
    categoryList,
    createcategory,
    getcategoryById,
    deletecategory,
    updatecategory,
    getCategoryOptions,
    loading,
    error,
  };
};

export default useCategory;
